<template>
  <span v-html="getIcon(props.name)" :class="getClass" />
</template>
<script lang="ts" setup>
import { computed, withDefaults, defineProps } from 'vue';
import get from 'lodash/get';
import * as icons from './../theme/icons';

const props = withDefaults(
  defineProps<{
    name: string;
    size?: 'xs' | 'sm' | 'base' | 'lg';
  }>(),
  {
    size: 'base',
  }
);

const getIcon = (name: string) => {
  const icon = get(icons, name, null);
  if (name === null) {
    console.warn(`[IconComponent] - cannot find icon ${props.name}`);
  }

  return icon;
};

const getClass = computed(() => ['sb-icon', `sb-icon-${props.size}`]);
</script>

<style scoped>
.sb-icon-lg {
  @apply w-8 h-8;
}
.sb-icon-base {
  @apply w-6 h-6;
}
.sb-icon-sm {
  @apply w-5 h-5;
}
.sb-icon-xs {
  @apply w-4 h-4;
}
.sb-icon {
  @apply block;
}
.sb-icon :deep(svg) {
  @apply w-full h-full;
}
</style>
